
import {createAxiosInstance} from "./createAxiosInstance";
export const getAxiosInstanceApi = () => {
    return createAxiosInstance('application/json');
};

export const getAxiosMultiPartInstanceApi = () => {
    return createAxiosInstance('multipart/form-data');
};
